module.exports = "/_next/static/images/4e715b114a74b6ae01e5f30b5c840bbd-man-looking-up-smiling-lg@2x.jpg";